import { render, staticRenderFns } from "./productionList.vue?vue&type=template&id=12f88368&scoped=true"
import script from "./productionList.vue?vue&type=script&lang=js"
export * from "./productionList.vue?vue&type=script&lang=js"
import style0 from "./productionList.vue?vue&type=style&index=0&id=12f88368&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f88368",
  null
  
)

export default component.exports